<div
  class="box tax-card d-flex flex-column"
  [class.shadow]="isGrid()"
  [class.h-100]="isGrid()"
  [class.shadow-sm]="!isGrid()">
  <div class="d-flex">
    <h5 class="col-11">
      <b>{{ taxNews().name }}</b>
    </h5>
    @if (isGrid()) {
      <gstar-action-menu
        *gstarCanEditCountry="taxNews().countryId"
        class="col-1"
        [actionMenu]="actionMenu"
        [rowData]="taxNews()" />
    }
  </div>

  <div class="align-items-end mt-auto">
    <div class="text-card">
      <p>{{ taxNews().countryName }}</p>
      <p>
        <span class="Appkit4-icon icon-calendar-outline"></span>
        {{ taxNews().date | date: 'mediumDate' }}
      </p>
    </div>
  </div>
</div>
